<!-- Grid Highlight Item Wrapper -->
<div
    class="grid-highlight-item"
    [ngClass]="enableNewGridHighlight ? 'new-grid-highlight-item' : 'old-grid-highlight-item'">
    <a
        [ngClass]="{ 'grid-highlight-slider': enableNewGridHighlight }"
        (click)="onItemClick($event)"
        [attr.aria-label]="enableNewGridHighlight ? getAriaLabel() : highlightedItemFilter.name"
        [fragment]="getFragment()"
        [queryParams]="getQueryParams()"
        [routerLink]="[]"
        (focus)="onFocus.emit()">
        <div class="swiper-slide">
            @if (highlightItemIndex < minHighlightLength) { @if (highlightItemIndex < minHighlightLength) {
            <img
                [ngClass]="{ 'new-grid-highlight-item-img': enableNewGridHighlight }"
                [alt]="highlightedItemFilter.name"
                [attr.aria-hidden]="'true'"
                [attr.src]="assetUrl$ | async"
                [attr.role]="'presentation'" />
            } } @else {

            <img
                [ngClass]="{ 'new-grid-highlight-item-img': enableNewGridHighlight }"
                [alt]="highlightedItemFilter.name"
                [attr.aria-hidden]="'true'"
                [src]="assetUrl$ | async"
                [attr.role]="'presentation'"
                class="swiper-lazy"
                loading="lazy" />

            }
        </div>
        <div
            [attr.role]="'text'"
            [class.new-grid-highlight-item-title]="enableNewGridHighlight"
            [class.grid-highlight-item-title]="!enableNewGridHighlight">
            <span class="highlight-name">{{ highlightedItemFilter.name }}</span>
        </div>
    </a>
</div>
<!-- END Grid Highlight Item Wrapper -->
